export const doctor_status_style = {
  rootsx: {},
};
